import React, { useEffect, useState } from "react";
import { Card, Container, List } from "./styles";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../../../services/api";
import { useAuth } from "../../../hooks/AuthContext";
import { toast } from "react-toastify";
import Status from "../../../components/status";
import { addSeconds, format, intervalToDuration } from "date-fns";
import { Button, Pagination, Select, Spin, Modal } from "antd";
import { formatarDuracaoCompleta } from "../../../services/functions";
import { Message, ViewInput } from "../../../GlobalStyles";
import CountUp from "react-countup";

export default function SolicitacoesTecnicos() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(() => {
    return Number(searchParams.get("page")) || 0;
  });
  const [orders, setOrders] = useState([]);
  const [ordersTotal, setOrdersTotal] = useState(0);
  const [user_id, setUser_id] = useState(() => {
    return searchParams.get("user_id") || "";
  });
  const [users, setUsers] = useState([]);
  const [status, setStatus] = useState(() => {
    return searchParams.get("status") || "";
  });

  const [visibleModalItems, setVisibleModalItems] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    loadingTecnicos();
  }, []);

  useEffect(() => {
    setSearchParams({ page, user_id, status }, { replace: true });
    loadingOSs(status, user_id, page);
  }, [status, user_id, page]);

  async function loadingTecnicos() {
    await api
      .get(`/users?all=true`)
      .then((response) => {
        setUsers(response.data.users);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function loadingOSs() {
    setLoading(true);
    await api
      .get(
        `/orders/${user.type}?page=${page}${status && `&status=${status}`}${
          user_id && `&user_id=${user_id}`
        }`,
      )
      .then((response) => {
        const formattedOrders = (response.data.orders || []).map((item) => {
          let tS = item.totalServices;
          if (tS === undefined && item.items) {
            tS = item.items.reduce((acc, curr) => acc + (curr.amount || 0), 0);
          }
          return {
            ...item,
            totalServices: tS || 0,
          };
        });
        setOrders(formattedOrders);
        setOrdersTotal(response.data.ordersTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  return (
    <Container>
      <h1>Minhas OSs</h1>
      <Card>
        <p>Total</p>
        <CountUp separator="." duration={1} end={ordersTotal} />
      </Card>
      {loading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              marginBottom: 25,
            }}
          >
            <ViewInput
              style={{ width: "100%", maxWidth: 200, marginRight: 15 }}
            >
              <p>Filtrar por Franqueado</p>
              <Select
                placeholder="selecionar franqueado"
                value={user_id}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setUser_id(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos Franqueados</Select.Option>
                {users.map((item) => {
                  return (
                    <Select.Option value={item.id}>{item.name}</Select.Option>
                  );
                })}
              </Select>
            </ViewInput>
            <ViewInput
              style={{ width: "100%", maxWidth: 200, marginRight: 15 }}
            >
              <p>Filtrar por Status</p>
              <Select
                placeholder="selecionar status"
                value={status}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setStatus(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos Status</Select.Option>
                <Select.Option value="andamento">Em andamento</Select.Option>
                <Select.Option value="finalizado">Finalizado</Select.Option>
                <Select.Option value="alteracao">
                  Alteração Solicitada
                </Select.Option>
                <Select.Option value="pendente">
                  Documentação Pendente
                </Select.Option>
                <Select.Option value="pagamento">
                  Aguardando Pagamento
                </Select.Option>
                <Select.Option value="recusado">Recusado</Select.Option>
                <Select.Option value="cancelado">Cancelado</Select.Option>
                <Select.Option value="aberto">Aguardando Técnico</Select.Option>
              </Select>
            </ViewInput>
          </div>
          <>
            {orders.length == 0 && (
              <Message>Nenhuma Ordem de Serviço encontrada</Message>
            )}
            <div className="orders">
              {orders.map((item) => {
                return (
                  <div className="order">
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {item.urgent && (
                        <Status
                          isUrgent={true}
                          style={{
                            marginRight: 10,
                            marginBottom: 7,
                            flexFlow: "nowrap",
                          }}
                        />
                      )}
                      {item.name && (
                        <p
                          style={{
                            width: "100%",
                            fontSize: 11,
                            marginBottom: 8,
                          }}
                        >
                          {item.name}
                        </p>
                      )}
                    </div>
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <p className="title" style={{ marginBottom: 5 }}>
                        {("00000" + item.id).slice(-5)}
                      </p>
                      <Button
                        type="link"
                        className="back"
                        style={{
                          fontSize: 12,
                          fontWeight: 600,
                          padding: "4px 12px",
                          height: "auto",
                          background: "#fff",
                          borderRadius: "50px",
                          color: "#52c41a",
                          border: "1px solid #b7eb8f",
                          display: "inline-flex",
                          alignItems: "center",
                          marginLeft: 0,
                          alignSelf: "flex-start",
                          maxWidth: "none",
                        }}
                        onClick={() => {
                          setSelectedItems(item.items || []);
                          setVisibleModalItems(true);
                        }}
                      >
                        {item.totalServices} serviço{item.totalServices !== 1 && "s"}
                      </Button>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ minWidth: 220, marginRight: 50 }}>
                        <p className="title">Status</p>
                        <Status status={item.status} urgent={item.urgent} />
                      </div>
                      <div className="item" style={{ marginRight: 25 }}>
                        <p className="title">Última atualização</p>
                        <p
                          className="back"
                          style={{
                            fontSize: 12,
                          }}
                        >
                          {format(new Date(item.update_at), "dd/MM/yyyy HH:mm")}
                        </p>
                      </div>
                    </div>

                    <div className="item" style={{ width: 150 }}>
                      <p className="title">Franqueado</p>
                      <p
                        className="back"
                        style={{
                          fontSize: 12,
                          maxWidth: 150,
                        }}
                      >
                        {item.user?.name || "Não encontrado"}
                      </p>
                    </div>
                    <Button
                      type="primary"
                      onClick={() => {
                        navigate("/tecnico/os/" + item.id);
                      }}
                    >
                      Detalhes
                    </Button>

                    {!!item.averageTime && (
                      <p style={{ width: "100%", fontSize: 11, marginTop: 10 }}>
                        OS concluida em{" "}
                        {formatarDuracaoCompleta(
                          intervalToDuration({
                            start: new Date(),
                            end: addSeconds(new Date(), item.averageTime),
                          }),
                        )}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
            <Pagination
              style={{
                margin: "25px 0",
                alignSelf: "center",
              }}
              defaultCurrent={page + 1}
              pageSize={30}
              onChange={(page) => {
                setPage(page - 1);
              }}
              total={ordersTotal}
            />
          </>
        </>
      )}
      <Modal
        title="Listagem de Serviços"
        open={visibleModalItems}
        onCancel={() => setVisibleModalItems(false)}
        footer={[
          <Button key="close" onClick={() => setVisibleModalItems(false)}>
            Fechar
          </Button>,
        ]}
      >
        {selectedItems.length > 0 ? (
          <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontWeight: "bold",
                borderBottom: "1px solid #f0f0f0",
                padding: "10px 0",
              }}
            >
              <span>Serviço</span>
              <span>Quantidade</span>
            </div>
            {selectedItems.map((item, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px 0",
                  borderBottom: "1px solid #f0f0f0",
                }}
              >
                <span>{item.name}</span>
                <span>{item.amount}x</span>
              </div>
            ))}
          </div>
        ) : (
          <p>Nenhum serviço encontrado para esta OS.</p>
        )}
      </Modal>
    </Container>
  );
}
